/**
 * @file index.js
 * @author Samuel Vazquez Ruiz
 * @description Initialize Patients Massive Processing View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './patientsMassiveProcessingView';

export const mapStateToPropsPatientManagement = mapStateToProps;
export const mapDispatchToPropsPatientManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientManagement,
  mapDispatchToPropsPatientManagement
)(View);
